const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ProductSearchServiceCommand: any = {
    PostGetSearchInformation: Backofficebff + '/v1/productstocks/getoptionids',
    GetStockByProduct: Backofficebff + '/v1/productstocks/getstockbyproduct',
    InventoryLastSync: Backofficebff + '/v1/productstocks/updateinventorylastsync',
    GetOptionSummary: Backofficebff + '/v1/productstocks/getoptionsummaries',
};
